import { WESOG_STORE_PARAMS } from '@core/constants/STORE';
import { getStoreValue, updateStoreValue } from './store';
import { DEFAULT_LANGUAGE } from '@core/constants/DEFAULT';
import { LANGUAGES } from '@core/constants/LANGUAGE';

/**
 * Get the current language.
 * @returns {string} - The current language.
 */
export const getSelectedLanguage = () => {
    const pathname = window.location.pathname;

    if (pathname.includes('/en/')) {
        updateStoreValue(WESOG_STORE_PARAMS.CURRENT_LANGUAGE, LANGUAGES.EN);

        return LANGUAGES.EN;
    }

    return (
        window.wesogSelectedLanguage ||
        getStoreValue(WESOG_STORE_PARAMS.CURRENT_LANGUAGE) ||
        navigator.language ||
        DEFAULT_LANGUAGE
    );
};
